import React from 'react';

const TpaVoucher = () => {
    return (
        <div>
            <h1>TpaVoucher</h1>
        </div>
    );
};

export default TpaVoucher;
